import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_BRANDS_URL = `${process.env.PUBLIC_URL}/api/v1/r/brands`;
export const GET_BRANDS = 'GET_BRANDS';
export const GET_BRANDS_COMPLETED = 'GET_BRANDS_COMPLETED';
export const GET_BRANDS_FAILED = 'GET_BRANDS_FAILED';
export function getBrands({salonId}) {
  const queryFilter = {
    where: {salonId: {eq: salonId}},
    order: "name ASC"
  };
  return queryAll(GET_BRANDS_URL, queryFilter, GET_BRANDS, GET_BRANDS_COMPLETED, GET_BRANDS_FAILED);
}

export const SEARCH_BRANDS = 'SEARCH_BRANDS';
export const SEARCH_BRANDS_COMPLETED = 'SEARCH_BRANDS_COMPLETED';
export const SEARCH_BRANDS_FAILED = 'SEARCH_BRANDS_FAILED';
export const searchBrands = querySearch(GET_BRANDS_URL, SEARCH_BRANDS, SEARCH_BRANDS_COMPLETED, SEARCH_BRANDS_FAILED,
  ['name', 'description']);

export const GET_BRAND = 'GET_BRAND';
export const GET_BRAND_COMPLETED = 'GET_BRAND_COMPLETED';
export const GET_BRAND_FAILED = 'GET_BRAND_FAILED';
export function getBrand({brandId}) {
  return queryOne(GET_BRANDS_URL, {where: {brandId}}, GET_BRAND, GET_BRAND_COMPLETED, GET_BRAND_FAILED);
}

const BRAND_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/brand`;
export const ADD_BRAND = 'ADD_BRAND';
export const ADD_BRAND_COMPLETED = 'ADD_BRAND_COMPLETED';
export const ADD_BRAND_FAILED = 'ADD_BRAND_FAILED';
export const addBrand = command(BRAND_ACTION_URL + '/addBrand', ADD_BRAND, ADD_BRAND_COMPLETED, ADD_BRAND_FAILED);

export const UPDATE_BRAND = 'UPDATE_BRAND';
export const UPDATE_BRAND_COMPLETED = 'UPDATE_BRAND_COMPLETED';
export const UPDATE_BRAND_FAILED = 'UPDATE_BRAND_FAILED';
export const updateBrand = command(BRAND_ACTION_URL + '/updateBrand', UPDATE_BRAND, UPDATE_BRAND_COMPLETED,
  UPDATE_BRAND_FAILED);

export const DELETE_BRAND = 'DELETE_BRAND';
export const DELETE_BRAND_COMPLETED = 'DELETE_BRAND_COMPLETED';
export const DELETE_BRAND_FAILED = 'DELETE_BRAND_FAILED';
export const deleteBrand = command(
  BRAND_ACTION_URL + '/deleteBrand',
  DELETE_BRAND,
  DELETE_BRAND_COMPLETED,
  DELETE_BRAND_FAILED
);

export const SHOW_DELETE_BRAND_MODAL = 'SHOW_DELETE_BRAND_MODAL';
export function showDeleteBrandModal(brand) {
  return {type: SHOW_DELETE_BRAND_MODAL, payload: brand};
}

export const HIDE_DELETE_BRAND_MODAL = 'HIDE_DELETE_BRAND_MODAL';
export function hideDeleteBrandModal() {
  return {type: HIDE_DELETE_BRAND_MODAL};
}


// WEBPACK FOOTER //
// ./src/Brand/actions.js